
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"export":"In Excel-Datei exportieren","toggleOrientation":"Position wechseln","horizontalLayout":"Rechts positionieren","verticalLayout":"Unten positionieren","customizeColumns":"Spalten ein-/ausblenden","close":"Schließen"},"en":{"export":"Export to Excel file","toggleOrientation":"Switch position","horizontalLayout":"Position to the right","verticalLayout":"Position at the bottom","customizeColumns":"Show/hide columns","close":"Close"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();